module.exports = __webpack_public_path__ + "media/images/common/icon/icon-login-b-cb69f7249a328af71320d3f5cd1d8bbb.svg";